/* eslint-disable */
import React, { useState } from 'react';

import useDidMount from 'hooks/useDidMount';
import { useAppSelector } from 'store/hooks';
import { useLocation } from 'react-router-dom';

const ChatPlugin: React.FC = () => {
  const location = useLocation();
  const [showed, setShowed] = useState(false);
  const chatElement = useAppSelector(
    (state) => state.system.dataSystem?.chatScripts,
  );

  useDidMount(() => {
    setTimeout(() => {
      setShowed(true);
    }, 5000);
    const processMessage = (message: MessageEvent<any>) => {
      const chatFrame = document.getElementById('ipccFrame');
      if (message.data === 'hide-chat' && chatFrame) {
        chatFrame.style.height = '116px';
        chatFrame.style.width = '76px';
      }
      if (message.data === 'open-chat' && chatFrame) {
        chatFrame.style.width = '300px';
        chatFrame.style.height = '625px';
      }
    };
    window.addEventListener('message', processMessage);

    return () => window.removeEventListener('message', processMessage);
  });

  if (!chatElement || !showed || location.pathname.includes('analysis-reports')) {
    return null;
  }

  return (
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: chatElement }}
    />
  );
};

export default ChatPlugin;
